import { render, staticRenderFns } from "./BaseCheckbox2.vue?vue&type=template&id=3fdab3dd&scoped=true"
import script from "./BaseCheckbox2.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox2.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckbox2.vue?vue&type=style&index=0&id=3fdab3dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdab3dd",
  null
  
)

export default component.exports